<template>
  <div :class="{ playerProgressActive, 'disabled': disabled} " class="player-progress" @mousedown="progressOnDown">
    <div ref="progressBar" class="progress-bar">
      <div ref="progress" :class="playerProgressMoving" class="progress">
        <!--  -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PlayerProgressBar',
  components: {},
  props: {
    setCurrentTime: {
      type: Function,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      progressOnActive: false,
      progressOnMoving: false
    }
  },
  computed: {
    initialClick() {
      return this.$store.state.player.initialClick
    },
    paused() {
      return this.$store.state.player.paused
    },
    currentTime() {
      return this.$store.state.player.currentTime
    },
    duration() {
      return this.$store.state.player.duration
    },
    playerProgressActive() {
      return this.progressOnActive ? 'active' : ''
    },
    playerProgressMoving() {
      return this.progressOnMoving ? 'moving' : ''
    }
  },
  watch: {
    currentTime(newValue, oldValue) {
      this.setProgressWidth(this.currentTime, this.duration)
    }
  },
  created() {},
  mounted() {},
  updated() {},
  methods: {
    setProgressWidth(clientX, total) {
      let percentage = Number.parseFloat(clientX / total).toFixed(5)
      if (percentage === 'NaN') { // NaN type strinfg
        percentage = 0
      }
      percentage = percentage > 1 ? 1 : percentage
      percentage = percentage < 0 ? 0 : percentage
      this.$refs.progress.style.width = (percentage * 100) + '%'
    },
    progressOnDown(e) {
      if (!this.duration) return
      this.progressOnActive = true
      this.playing = false
      this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
      document.body.addEventListener('mousemove', this.progressOnMove)
      document.body.addEventListener('mouseup', this.progressOnUp)
    },
    progressOnMove(e) {
      e.stopPropagation()
      e.preventDefault() // prevent other select event!
      this.progressOnMoving = true
      this.setProgressWidth(e.clientX, this.$refs.progressBar.clientWidth)
    },
    progressOnUp(e) {
      document.body.removeEventListener('mousemove', this.progressOnMove)
      document.body.removeEventListener('mouseup', this.progressOnUp)
      this.progressOnMoving = false
      this.progressOnActive = false
      this.setProgressWidth(e.clientX, this.$refs.progressBar.clientWidth)
      const mouseUppercentage = (e.clientX / this.$refs.progressBar.clientWidth).toFixed(5)
      const newTime = Number.parseInt(mouseUppercentage * this.duration)
      this.setCurrentTime(newTime)
      //
      if (!this.initialClick) {
        // Trigger click-to-play policy
        document.querySelector('#audioPlayer').play()
        document.querySelector('#audioPlayer').pause()
      }
      this.$store.commit('TOGGLE_PLAYER_PAUSED', false)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.player-progress {
  z-index: 2;
  position: absolute;
  top: 0;
  height: 6px;
  width: 100%;
  // transition: height .3s ease, top .3s ease;
  cursor: pointer;
  .progress {
    &-bar {
      height: 100%;
      width: 100%;
      border-radius: 12px 12px 0 0;

      background-color: $grey-e3;
    }
    position: relative;
    border-radius: 12px 12px 12px 0;
    width: 0;
    height: 100%; // height + padding, more comfortable transition effect
    background-color: $theme-yellow;

    transition: width .2s linear;
    &:not(.moving){
      // transition: width .3s linear;
    }
    &::before {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 0;
      height: 0;
      background-color: $theme-yellow;
      border-radius: 100%;
      transition: .2s linear;
      // transform: rotate(90deg);
    }
  }
  &.active,
  &:hover {
    height: 8px;
    top: -2px;
    .progress {
      &::before {
        right: -6px;
        top: -6px;
        width: 18px;
        height: 18px;
      }
    }
  }
  &.disabled{
    pointer-events: none;
    cursor: not-allowed;
  }
}
</style>
